import React, { Component } from 'react'
import { Content } from './styles'

import ProfileGroup from '../ProfileGroup'

class Main extends Component {
  render() {
    return(
      <Content>
        <header>
          <h1>178.62.48.148</h1>
          <h1>You found us because we wanted to be found.</h1>
          <p>Why do you care about the people with no faces?</p>
        </header>
        <ProfileGroup />
      </Content>
    )
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/Components/Main/index.js